import React from "react";
var INPUT_TAGS = [
    "input",
    "textarea",
    "select"
];
var isHTMLElement = function(target) {
    return target !== document && target !== window;
};
var isInput = function(element) {
    return INPUT_TAGS.includes(element.tagName.toLowerCase());
};
var isContentEditable = function(element) {
    return element.hasAttribute("contenteditable");
};
// INFO: Used to check whether user was typing something inside an input
// or using a single-key global keyboard shortcut.
export default function isKeyboardEventFromInput(event) {
    var target = event.target;
    return isHTMLElement(target) && (isInput(target) || isContentEditable(target));
}
